import React from 'react';
import OfficialTraining from '../training/OfficialTraining';
import TrainingRequestForm from '../training/request/TrainingRequestForm';
import Card from '../common/Card';
import { useTranslatedContent } from '../../hooks/useTranslatedContent';

const TrainingSection = () => {
  const { t } = useTranslatedContent('request');

  return (
    <div id="training" className="bg-white">
      <OfficialTraining />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <Card className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900">
              {t('title')}
            </h3>
            <p className="mt-2 text-gray-600">
              {t('subtitle')}
            </p>
          </div>
          <TrainingRequestForm />
        </Card>
      </div>
    </div>
  );
};

export default TrainingSection;